import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.dark,
    marginTop: theme.spacing(1),
  },
  inputBackgroundColor: {
    backgroundColor: "#F8F8F8",
  },

  input: {
    marginRight: theme.spacing(1),
  },
  deletePosition: {
    position: "absolute",
    top: -10,
    right: -10,
  },
}))

export default styles
